import { createNextTableContext } from '@core/table';

export const CountriesTableContext = createNextTableContext();
